import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
  withStyles
} from "@material-ui/core";
import styles from "../../../wrappers/admin/Admin.Styles";
import * as AccountHierarchyActions from "../../../store/AccountHierarchy";
import * as SnackbarActions from "../../../store/SnackbarStore";
import * as AccountActions from "../../../store/AccountStore";
import { userInRoles, UserRoleTypeEnum } from "../../..//services/authService";
import HierarchyManager from "../../../components/HierarchyManager";
import Hierarchy, { HierarchyMode } from "../../../components/Hierarchy";
import DragSourceList, {
  DragSourceListMode
} from "../../../components/DragSourceList";
import { dndType } from "../../../components/DragSourceList";
import differenceWith from "lodash/differenceWith";
import { WBToolbarMode } from "../../../components/WBToolbar";

class AccountApp extends Component {
  hierarchyType = "Account";
  hierarchyTypeId = 1;

  componentWillReceiveProps(nextProps) {
    const { accounts, hierarchyElements } = nextProps;
    this.setState({
      accounts: differenceWith(
        accounts,
        hierarchyElements,
        (a, h) => a.id === h.entityId
      )
    });
    this.updateAccounts(this.state.selectAccountType);
  }

  updateAccounts = selectAccountType => {
    const { accountTypeMaps } = this.props;
    const { accounts } = this.state;
    //Find the selected Account Type Map
    const displayedAccountTypes = accountTypeMaps.filter(at => {
      return at.name == selectAccountType;
    });

    let filteredAccounts = accounts;
    if (displayedAccountTypes && displayedAccountTypes.length > 0) {
      filteredAccounts = accounts.filter(a => {
        return (
          displayedAccountTypes.findIndex(
            at => a.typeSequence === at.typeSequence
          ) > -1
        );
      });
    }
    this.setState({ filteredAccounts: filteredAccounts });
  };

  componentDidMount() {
    const {
      requestHierarchies,
      requestAccounts,
      requestAccountTypeMaps
    } = this.props;
    requestHierarchies(this.hierarchyType);
    requestAccountTypeMaps();
    requestAccounts();
  }

  state = {
    hierarchyId: 0,
    accounts: [],
    selectAccountType: "None",
    filteredAccounts: []
  };

  hierarchyChange = hierarchyId => {
    this.setState({ hierarchyId: Number(hierarchyId) });
  };

  hierarchyModified = ({ hierarchyId }) => {
    const { requestHierarchies } = this.props;
    requestHierarchies(this.hierarchyType);
  };

  hierarchyDeleted = ({ hierarchyId }) => {
    const { requestHierarchies } = this.props;
    this.hierarchyChange(0);
    requestHierarchies(this.hierarchyType);
  };

  accountTypeChanged = val => {
    this.setState({ selectAccountType: val.target.value });
    this.updateAccounts(val.target.value);
  };

  render() {
    const { classes, hierarchies, distinctAccountTypeMaps, user } = this.props;
    const { filteredAccounts } = this.state;

    let hierarchyMode = userInRoles(user, [UserRoleTypeEnum.Administrator])
      ? HierarchyMode.EDIT
      : HierarchyMode.READ;
    let dragSourceListMode = userInRoles(user, [UserRoleTypeEnum.Administrator])
      ? DragSourceListMode.EDIT
      : DragSourceListMode.READ;

    return (
      <div>
        <Typography variant="h4" gutterBottom component="h2">
          Account Hierarchy
        </Typography>

        <div className={classes.root}>
          <Grid container spacing={8}>
            <Grid item xs={6}>
              <HierarchyManager
                hierarchies={hierarchies}
                hierarchyChange={this.hierarchyChange}
                hierarchyDeleted={this.hierarchyDeleted}
                hierarchyAdded={this.hierarchyModified}
                hierarchyUpdated={this.hierarchyModified}
                hierarchyTypeId={this.hierarchyTypeId}
              />
            </Grid>
            <Grid item xs={6}>
              {this.state.hierarchyId > 0 ? (
                <form autoComplete="off">
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="accounttype-select">
                      Account Type
                    </InputLabel>
                    <Select
                      value={this.state.selectAccountType}
                      onChange={this.accountTypeChanged}
                      inputProps={{
                        name: "selectAccountType",
                        id: "selectAccountType"
                      }}
                      className={classes.textFieldMed}
                    >
                      <MenuItem value="None">
                        <em>None</em>
                      </MenuItem>
                      {distinctAccountTypeMaps.map(a => {
                        return (
                          <MenuItem key={a} value={a}>
                            {a}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </form>
              ) : (
                undefined
              )}
            </Grid>
          </Grid>
        </div>

        {this.state.hierarchyId > 0 ? (
          <div className={classes.root}>
            <Grid container spacing={8}>
              <Grid item xs={6}>
                <Paper className={classes.paper} style={{ maxHeight: 600 }}>
                  <Hierarchy
                    dndType={dndType}
                    hierarchyId={this.state.hierarchyId}
                    hierarchyTypeId={this.hierarchyTypeId}
                    hierarchyMode={hierarchyMode}
                  />
                </Paper>
              </Grid>
              <Grid item xs={6}>
                <Paper className={classes.paper} style={{ maxHeight: 600 }}>
                  <DragSourceList
                    accounts={filteredAccounts}
                    dragSourceListMode={dragSourceListMode}
                  />
                </Paper>
              </Grid>
            </Grid>
          </div>
        ) : (
          undefined
        )}
      </div>
    );
  }
}

function groupBy(list, key) {
  let unique = [];
  list.map(i => {
    if (unique.findIndex(u => u == i[key]) < 0) {
      unique.push(i[key]);
    }
  });
  return unique;
}

function mapStateToProps(state) {
  return {
    hierarchies: state.accountHierarchy.hierarchies
      ? state.accountHierarchy.hierarchies
      : [],
    accounts: state.accounts.accounts ? state.accounts.accounts : [],
    accountTypeMaps: state.accounts.accountTypeMaps
      ? state.accounts.accountTypeMaps
      : [],
    distinctAccountTypeMaps: state.accounts.accountTypeMaps
      ? groupBy(state.accounts.accountTypeMaps, "name")
      : [],
    hierarchyElements: state.accountHierarchy.hierarchyElements || [],
    user: state.user.user
  };
}

export default connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign(
        {},
        AccountHierarchyActions.actionCreators,
        AccountActions.actionCreators,
        SnackbarActions.actionCreators
      ),
      dispatch
    )
)(withStyles(styles)(DragDropContext(HTML5Backend)(AccountApp)));
